import { create } from 'zustand';
import type { AuthResponse, UserProfile, UserResponse } from '../types/user';
import { UserRole } from '../types/user';
import { clearAuth, persistAuth } from '../services/auth';
import { getCurrentUser } from '../services/users';
import { STORAGE_ACCESS } from '../lib/constants';

function toProfile(u: UserResponse): UserProfile {
  return {
    id: u.id,
    email: u.email,
    firstName: u.firstName,
    lastName: u.lastName,
    role: u.role,
  };
}

type AuthState = {
  user: UserProfile | null;
  ready: boolean;
  setFromAuthResponse: (auth: AuthResponse) => void;
  setUserProfile: (user: UserProfile | null) => void;
  logout: () => void;
  hydrate: () => Promise<void>;
};

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  ready: false,

  setFromAuthResponse: (auth: AuthResponse) => {
    persistAuth(auth);
    set({ user: auth.user });
  },

  setUserProfile: (user: UserProfile | null) => {
    set({ user });
  },

  logout: () => {
    clearAuth();
    set({ user: null });
  },

  hydrate: async () => {
    const token = localStorage.getItem(STORAGE_ACCESS);
    if (!token) {
      set({ user: null, ready: true });
      return;
    }
    try {
      const me = await getCurrentUser();
      set({ user: toProfile(me), ready: true });
    } catch {
      get().logout();
      set({ ready: true });
    }
  },
}));

export function roleMatches(user: UserProfile | null, role: UserRole): boolean {
  return user?.role === role;
}
